import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';

import OnTraccrButton from '../../buttons/OnTraccrButton';
import { hasSavedSectionLayout } from '../pdfHelpers';

const formStyle = { marginBottom: 12 };

export default function PDFRepeatableSectionConfigure({
  onLinkChanged,
  onOpenRepeatableSectionLayout,
  onClearRepeatableSectionLayout,
  field: {
    link = {},
    sectionLayoutDrawOptions,
  } = {},
  sections,
}) {
  const repeatableSections = useMemo(() => (
    sections.filter(({ settings: { isDuplicationEnabled = false } = {} }) => isDuplicationEnabled)
  ), [sections]);

  const hasCustomLayout = hasSavedSectionLayout(sectionLayoutDrawOptions);

  return (
    <>
      <Form.Item key="section" label="Section" style={formStyle}>
        <Select
          value={link.sectionId}
          placeholder="Select a section"
          onChange={(sectionId) => onLinkChanged({ sectionId })}
          allowClear
        >
          {repeatableSections.map(({ id, name }) => (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item style={formStyle}>
        <OnTraccrButton
          title="Configure layout"
          type="primary"
          disabled={!link.sectionId}
          onClick={onOpenRepeatableSectionLayout}
          style={{ width: '100%' }}
        />
      </Form.Item>
      {hasCustomLayout && (
        <Form.Item style={formStyle}>
          <OnTraccrButton
            title="Clear custom layout"
            type="back"
            onClick={onClearRepeatableSectionLayout}
            style={{ width: '100%' }}
          />
        </Form.Item>
      )}
    </>
  );
}

PDFRepeatableSectionConfigure.propTypes = {
  onLinkChanged: PropTypes.func.isRequired,
  onOpenRepeatableSectionLayout: PropTypes.func.isRequired,
  onClearRepeatableSectionLayout: PropTypes.func.isRequired,
  field: PropTypes.shape({
    link: PropTypes.shape({
      sectionId: PropTypes.string,
    }),
    sectionLayoutDrawOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  }),
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})),
  })),
};

PDFRepeatableSectionConfigure.defaultProps = {
  field: {},
  sections: [],
};
